export default __webpack_public_path__ + "static/media/Fantasy_01.c57dd900.png";